export default __webpack_public_path__ + "static/media/contact-2.63746e52.png";